import { ExistingActionField } from 'schemaBuilder/types';
import { test as validate, enforce } from 'vest';

export default (field: ExistingActionField, fieldPath: string) => {
  validate(`${fieldPath}.ref`, `Please fill the required fields`, () => {
    enforce(field.ref).isNotEmpty();
  });
};
